"use client";

import classNames from "classnames";

import styles from "./styles/Markdown.module.scss";
import { memo } from "react";

function arePropsEqual(oldProps, newProps) {
  return JSON.stringify(oldProps) === JSON.stringify(newProps);
}

export default memo(function Markdown({
  withStyles = false,
  source,
  className = "",
  baseFontSizePx = 18,
  ...restProps
}: {
  withStyles?: boolean;
  source?: string;
  className?: string;
  baseFontSizePx?: number;
  [key: string]: any;
}) {
  const markdownClassname = classNames({
    [styles.markdown]: withStyles === true,
    [className]: true,
  });

  const style = {
    fontSize: withStyles ? baseFontSizePx : undefined,
    ...(restProps.style || {}),
  };

  return (
    <div
      className={markdownClassname}
      style={style}
      {...restProps}
      translate={"yes"}
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: source || "" }}
    />
  );
}, arePropsEqual);
